// Entertainment system license keys
export const validLicenses = {
  'RSC Uttigen': 'rsc1980'
};
